<template>
    <b-card title="">
        <h3 class="text-primary font-weight-bold mb-2">ข้อมูลด่านชายแดน</h3>
        <b-row>
            <b-col md="6">
                <h5 class="h4 font-weight-bold">ชื่อด่านชายแดน</h5>
                <b-form-group label="" label-for="stationName">
                    <b-form-input v-model="formUser.stationName" placeholder="ชื่อด่านชายแดน"
                        :class="{ 'is-invalid': showError && !formUser.stationName }" />
                </b-form-group>
            </b-col>
            <b-col md="6">
                <h5 class="h4 font-weight-bold">จำนวนลิมิตต่อวัน</h5>
                <b-form-group label="" label-for="dailyLimit">
                    <b-form-input v-model="formUser.dailyLimit" placeholder="จำนวนลิมิตต่อวัน"
                        :class="{ 'is-invalid': showError && !formUser.dailyLimit }" />
                </b-form-group>
            </b-col>


            <b-col md="6">
                <div>
                    <h5 class="h4 font-weight-bold">รายละเอียด</h5>
                    <b-form-textarea id="textarea-default" v-model="formUser.description" placeholder="รายละเอียด"
                        rows="3" />
                </div>
            </b-col>


        </b-row>
        <br></br>
        <b-col cols="12">
            <b-button variant="primary" type="submit" @click.prevent="validationForm">
                บันทึกข้อมูล
            </b-button>
        </b-col>
        <b-col md="6">
            <br />
            <h3 class="text-primary font-weight-bold mb-2">
                ข้อมูลด่านชายแดน
            </h3>
        </b-col>
        <b-row>

            <b-col md="6" sm="4" class="my-1">
                <b-form-group class="mb-0">
                    <label class="h5 d-inline-block text-sm-left mr-50">จำนวนต่อหน้า</label>
                    <b-form-select id="perPageSelect" v-model="perPage" size="sm" :options="pageOptions" class="w-50" />
                </b-form-group>
            </b-col>
            <b-col md="6" class="my-1">
                <b-form-group label="ค้นหา" label-cols-sm="3" label-align-sm="right" label-size="sm"
                    label-for="filterInput" class="h5 mb-0">
                    <b-input-group size="sm">
                        <b-form-input id="filterInput" v-model="filter" type="search" placeholder="พิมพ์เพื่อค้นหา" />
                        <b-input-group-append>
                            <b-button :disabled="!filter" @click="filter = ''">
                                ยกเลิก
                            </b-button>
                        </b-input-group-append>
                    </b-input-group>
                </b-form-group>
            </b-col>
        </b-row>

        <b-col cols="12">
            <b-table striped hover responsive :current-page="currentPage" :items="items" :fields="fields"
                :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection" :filter="filter"
                :filter-included-fields="filterOn" @filtered="onFiltered">
                <!-- 👇 CUSTOM ACTION COLUMN -->
                <template #cell(action)="props">
                    <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
                        <template #button-content>
                            <feather-icon icon="MoreVerticalIcon" size="16" class="text-body align-middle mr-25" />
                        </template>
                        <b-dropdown-item @click="editItem(props.item)">
                            <feather-icon icon="Edit2Icon" class="mr-50" />
                            <span>แก้ไข</span>
                        </b-dropdown-item>

                        <b-dropdown-item @click="confirmText(props.item)">
                            <feather-icon icon="TrashIcon" class="mr-50" />
                            <span>ลบ</span>
                        </b-dropdown-item>
                    </b-dropdown>
                </template>
            </b-table>
        </b-col>

        <!-- Pagination -->
        <b-card v-show="true" class="p-0 mb-1" no-body>
            <b-nav class="navbar d-flex justify-content-between bd-highlight flex-wrap">
                <div>
                    Showing {{ (currentPage - 1) * perPage + 1 }} to
                    {{ Math.min(currentPage * perPage, totalRows) }}
                    of {{ totalRows }} entries
                </div>
                <!-- {{currentPage}} -->
                <div class="bd-highlight">
                    <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage"
                        @input="handlePageChange" class="mb-0" first-text="First" prev-text="Prev" next-text="Next"
                        last-text="Last" align="left" hide-goto-end-buttons />
                </div>
            </b-nav>
        </b-card>

        <b-modal id="edit-modal" title="แก้ไขข้อมูล" v-model="showEditModal" @ok="saveEdit" ok-title="บันทึก"
            cancel-title="ยกเลิก">
            <b-form-group label="ชื่อสถานี" label-for="stationName">
                <b-form-input v-model="editForm.stationName" id="stationName" />
            </b-form-group>

            <b-form-group label="จำนวนจำกัดต่อวัน" label-for="dailyLimit">
                <b-form-input v-model="editForm.dailyLimit" id="dailyLimit" type="number" />
            </b-form-group>

            <b-form-group label="คำอธิบาย" label-for="description">
                <b-form-textarea v-model="editForm.description" id="description" />
            </b-form-group>

            <!-- เพิ่มฟิลด์อื่น ๆ ตามที่ต้องการ -->
        </b-modal>

        <div class="demo-inline-spacing">
            <!-- <div>
        <h5>Confirm Button Text</h5>
        <b-button
          v-ripple.400="'rgba(113, 102, 240, 0.15)'"
          variant="outline-primary"
          @click="confirmText"
        >
          Confirm Text
        </b-button>
      </div> -->
            <!-- <div>
      <h5>Confirm Button Text</h5>
      <b-button
        v-ripple.400="'rgba(113, 102, 240, 0.15)'"
        variant="outline-primary"
        @click="confirmButtonColor"
      >
        Confirm Button Color
      </b-button>
    </div> -->
        </div>
    </b-card>
</template>

<script>
import {
    BTable,
    BAvatar,
    BBadge,
    BRow,
    BCol,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
} from "bootstrap-vue";
import { BCard, BCardText } from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import store from "@/store/index";
import API from "@/connect/config";
import axios from "axios";

export default {
    components: {
        BTable,
        BAvatar,
        BBadge,
        BRow,
        BCard,
        BCardText,
        BCol,
        BFormGroup,
        BFormSelect,
        BPagination,
        BInputGroup,
        BFormInput,
        BInputGroupAppend,
        BButton,
    },
    directives: {
        Ripple,
    },
    data() {
        return {
            perPage: 100,
            pageOptions: [25, 50, 100],
            totalRows: 1,
            currentPage: 1,
            sortBy: "",
            sortDesc: false,
            sortDirection: "asc",
            filter: null,
            filterOn: [],
            infoModal: {
                id: "info-modal",
                title: "",
                content: "",
            },
            fields: [
                {
                    key: "name",
                    label: "ชื่อด่านชายแดน",
                },
                {
                    key: "dailyLimit",
                    label: "จำนวนลิมิตต่อวัน",
                },
                {
                    key: "description",
                    label: "รายละเอียด",
                },

                { key: "action", label: "แก้ไข/ลบ" }, // ✅ เพิ่มตรงนี้
            ],
            items: [],
            selected: null,
            formUser: {
                stationName: "",
                dailyLimit: "",
                description: "",
                isActive: "true",
            },
            showError: false,
            showEditModal: false,
            editForm: {
                configId: null,
                stationName: "",
                dailyLimit: 0,
                description: "",
            },
        };
    },
    computed: {
        sortOptions() {
            // Create an options list from our fields
            return this.fields
                .filter((f) => f.sortable)
                .map((f) => ({ text: f.label, value: f.key }));
        },
    },
    created() {
        this.getDataTable();
    },
    mounted() {
        // Set the initial number of items
        this.totalRows = this.items.length;
    },
    methods: {
        info(item, index, button) {
            this.infoModal.title = `Row index: ${index}`;
            this.infoModal.content = JSON.stringify(item, null, 2);
            this.$root.$emit("bv::show::modal", this.infoModal.id, button);
        },
        resetInfoModal() {
            this.infoModal.title = "";
            this.infoModal.content = "";
        },
        onFiltered(filteredItems) {
            // Trigger pagination to update the number of buttons/pages due to filtering
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },
        editItem(item) {
            // เพิ่ม logic แก้ไข
            console.log("Edit:", item);
            this.editForm = { ...item };  // ก๊อปข้อมูลไปแก้ไข
            this.showEditModal = true;
        },
        async saveEdit() {
            const jwt = JSON.parse(localStorage.getItem("company_jwt"));

            const _data = {
                userId: jwt.userId,
                configId: this.editForm.configId,
                stationName: this.editForm.stationName,
                dailyLimit: this.editForm.dailyLimit,
                description: this.editForm.description,
            };

            console.log("Data to update:", _data);

            try {
                const res = await axios.put(`${API}config/`, _data,
                    {
                        headers: {
                            Authorization: await store.dispatch("getAuthorization"),
                        },
                    }
                );
                console.log("อัปเดตสำเร็จ:", res.data);

                this.$bvToast.toast("บันทึกสำเร็จ", {
                    title: "สำเร็จ",
                    variant: "success",
                    solid: true,
                });

                this.showEditModal = false;
                await this.getDataTable(); // รีโหลดตาราง
            } catch (err) {
                console.error("เกิดข้อผิดพลาด:", err);
                this.$bvToast.toast("เกิดข้อผิดพลาดในการบันทึก", {
                    title: "ผิดพลาด",
                    variant: "danger",
                    solid: true,
                });
            }
        },
        deleteItem(item) {
            console.log("Delete:", item);
            confirmText();
            // เพิ่ม logic ลบ
        },
        confirmText(item) {
            console.log("item:", item);
            console.log(item);

            this.$swal({
                title: "ลบข้อมูล?",
                text: "คุณต้องการจะลบข้อมูล ใช่หรือไม่!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "ลบ",
                cancelButtonText: "ยกเลิก",
                customClass: {
                    confirmButton: "btn btn-primary",
                    cancelButton: "btn btn-outline-danger ml-1",
                },
                buttonsStyling: false,
            }).then(async (result) => {
                if (result.value) {
                    const jwt = JSON.parse(localStorage.getItem("company_jwt"));

                    await axios
                        .delete(`${API}config`, {
                            data: {
                                userId: jwt.userId,
                                configId: item.configId,
                            },
                            // headers: {
                            //     Authorization: refreshToken, //await store.dispatch("getAuthorization"),
                            // },
                        })
                        .then(async (el) => {
                            console.log(el.data.message);
                            if (el.data.message == "Border station config deleted successfully") {
                                this.$swal({
                                    icon: "success",
                                    title: "ลบข้อมูล!",
                                    text: "ลบข้อมูลสำเร็จ",
                                    showCancelButton: false,
                                    showConfirmButton: true,
                                    timer: 1500,
                                    customClass: {
                                        confirmButton: "btn btn-success",
                                    },
                                });
                            }
                            this.getDataTable();
                        })
                        .catch((err) => {
                            if (err.response) {
                                console.error("❌ API Error:", err.response.status);
                                console.error("Response:", err.response.data);
                            } else {
                                console.error("❌ Error:", err.message);
                            }
                        });

                    return;
                }
            });
        },

        async getDataTable() {
            try {
                const jwt = JSON.parse(localStorage.getItem("company_jwt"));

                const params = {
                    userId: jwt.userId,
                    configType: "station",
                };
                console.log("API Request Params", params);
                const res = await axios.get(`${API}config`, {
                    params,
                    headers: {
                        Authorization: await store.dispatch("getAuthorization"),
                    },
                });
                const responseData = res.data.message.data;
           

                this.items = responseData;
                this.totalRows = responseData.length;
            } catch (err) {
                console.error("❌ Error:", err.response?.data || err.message);
            } finally {
                this.isBusy = false;
            }

            return;
            const jwt = JSON.parse(localStorage.getItem("company_jwt"));
            console.log(jwt);
            await axios
                .get(
                    `${API}allUserFromCompany?companyId=${jwt.companyId}&userId=${jwt.userId}`,
                    {
                        // headers: {
                        //   Authorization: await store.dispatch("getAuthorization"),
                        // },
                    }
                )
                .then((res) => {
                    console.log("✅ success");
                    console.log(res.data.message[0]);
                    this.items = res.data.message[0].results;
                    console.log(this.items);
                })
                .catch((err) => {
                    if (err.response) {
                        console.error("❌ API Error:", err.response.status);
                        console.error("Response:", err.response.data);
                    } else {
                        console.error("❌ Error:", err.message);
                    }
                });



        },
        async validationForm() {
            !this.showError && this.formUser.stationName && this.formUser.dailyLimit;
            if (!this.formUser.stationName || !this.formUser.dailyLimit) {
                this.showError = true;
                return;
            } else {
                this.showError = false;
            }


            const { username, password, firstname, lastname } = this.formUser;
            const jwt = JSON.parse(localStorage.getItem("company_jwt"));
            // console.log(jwt);

            const _data = {
                userId: jwt.userId,
                name: this.formUser.stationName,
                dailyLimit: this.formUser.dailyLimit,
                description: this.formUser.description,
                configType: "station",
                isActive: 'true',
            };

            console.log("Data to send:", _data);


            axios
                .post(`${API}config`, _data, {
                    headers: {
                        Authorization: await store.dispatch("getAuthorization"),
                    },
                })
                .then(async (res) => {
                    console.log(res);
                    if (res.data.message.message == "Border station config created successfully") {
                        this.$swal({
                            icon: "success",
                            title: "บันทึกข้อมูล!",
                            text: "บันทึกข้อมูลสำเร็จ",
                            showCancelButton: false,
                            showConfirmButton: true,
                            timer: 1500,
                            customClass: {
                                confirmButton: "btn btn-success",
                            },
                        });
                        this.getDataTable();
                    }
                })
                .catch(async (error) => {
                    console.log(error.response);
                    this.$store.commit("setToastMessage", {
                        message: `${error.response.data.message}`,
                        title: "ผู้ใช้งาน limit",
                        variant: "danger",
                    });
                });
        },
        async handlePageChange(page) {
            console.log(page);
            this.currentPage = page;
            this.items = [];

            await this.getDataTable();
        },
        async handleItemsPerPageChange() {
            this.items = [];
            this.currentPage = 1;
            await this.getDataTable();
        },
    },
};
</script>